<app-header></app-header>
<section class="container-xxl">
    <!-- BREADCRUMB AREA - STARTS -->
    <div class="breadcrumb-area">

<!-- for content page  -->        
        <nav aria-label="breadcrumb mb-0" *ngIf="showEmpMen==false">
            <ol class="breadcrumb" *ngIf="check_total_current_menu > 0"> 
                <li class="breadcrumb-item"><a class="screen-reader" routerLink="/">{{ 'Home' | translate }}</a></li>
                <li class="breadcrumb-item" *ngIf="has_global_menu" [ngSwitch]="global_menu.INTLINKTYPE">
                    <!-- external page -->
                    <a href="javascript:void(0);" class="screen-reader" (click)='goToExtLink(global_menu.VCHEXTERNALLINK)' *ngSwitchCase="1" [ngClass]="current_menu.intId == global_menu.intId ? 'active-nemu' : ''">{{encDec.decodeHtml(language=='English'?global_menu.VCHMENUNAME:global_menu.VCHMENUNAMEHINDI)}}</a>
                    <!-- plugin page -->
                    <a href="javascript:void(0);" class="screen-reader" (click)="goToPluginPage(global_menu.INTPLUGIN,{'plugin_id':global_menu.intId,'selectPlugin':global_menu.INTPLUGIN})" *ngSwitchCase="2" [ngClass]="current_menu.intId == global_menu.intId ? 'active-nemu' : ''">{{encDec.decodeHtml(language=='English'?global_menu.VCHMENUNAME:global_menu.VCHMENUNAMEHINDI)}}</a>
                   <!-- content page -->
                   <a href="javascript:void(0);" class="screen-reader" (click)="goToContentPage(global_menu)" *ngSwitchCase="3" [ngClass]="pageAlias == global_menu.INTPLUGIN ? 'active-nemu' : ''">{{encDec.decodeHtml(language=='English'?global_menu.VCHMENUNAME:global_menu.VCHMENUNAMEHINDI)}}</a>
                   <!-- na -->
                   <a href="javascript:void(0);" class="screen-reader" *ngSwitchCase="4" [ngClass]="current_menu.intId == global_menu.intId ? 'active-nemu' : ''">{{encDec.decodeHtml(language=='English'?global_menu.VCHMENUNAME:global_menu.VCHMENUNAMEHINDI)}}</a>
                </li>
                <li class="breadcrumb-item"  *ngIf="has_primary_menu" [ngSwitch]="primary_menu.INTLINKTYPE">
                    <!-- external page -->
                    <a href="javascript:void(0);" class="screen-reader" (click)='goToExtLink(primary_menu.VCHEXTERNALLINK)' *ngSwitchCase="1" [ngClass]="current_menu.intId == primary_menu.intId ? 'active-nemu' : ''">{{encDec.decodeHtml(language=='English'?primary_menu.VCHMENUNAME:primary_menu.VCHMENUNAMEHINDI)}}</a>
                    <!-- plugin page -->
                    <a href="javascript:void(0);" class="screen-reader" (click)="goToPluginPage(primary_menu.INTPLUGIN,{'plugin_id':primary_menu.intId,'selectPlugin':primary_menu.INTPLUGIN})" *ngSwitchCase="2" [ngClass]="current_menu.intId == primary_menu.intId ? 'active-nemu' : ''">{{encDec.decodeHtml(language=='English'?primary_menu.VCHMENUNAME:primary_menu.VCHMENUNAMEHINDI)}}</a>
                   <!-- content page -->
                   <a href="javascript:void(0);" class="screen-reader" (click)="goToContentPage(primary_menu)" *ngSwitchCase="3" [ngClass]="current_menu.intId == primary_menu.intId ? 'active-nemu' : ''">{{encDec.decodeHtml(language=='English'?primary_menu.VCHMENUNAME:primary_menu.VCHMENUNAMEHINDI)}}</a>
                   <!-- na -->
                   <a href="javascript:void(0);" class="screen-reader" *ngSwitchCase="4" [ngClass]="current_menu.intId == primary_menu.intId ? 'active-nemu' : ''">
                    {{encDec.decodeHtml(language=='English'?primary_menu.VCHMENUNAME:primary_menu.VCHMENUNAMEHINDI)}}
                </a>
                </li>
                <li class="breadcrumb-item"  *ngIf="has_secondary_menu" [ngSwitch]="secondary_menu.INTLINKTYPE"> 
                    <!-- external page -->
                        <a href="javascript:void(0);" class="screen-reader" (click)='goToExtLink(secondary_menu.VCHEXTERNALLINK)' *ngSwitchCase="1" [ngClass]="current_menu.intId == secondary_menu.intId ? 'active-nemu' : ''">{{encDec.decodeHtml(language=='English'?secondary_menu.VCHMENUNAME:secondary_menu.VCHMENUNAMEHINDI)}}</a>
                    <!-- plugin page -->
                        <a href="javascript:void(0);" class="screen-reader" (click)="goToPluginPage(secondary_menu.INTPLUGIN,{'plugin_id':secondary_menu.intId,'selectPlugin':secondary_menu.INTPLUGIN})" *ngSwitchCase="2" [ngClass]="current_menu.intId == secondary_menu.intId ? 'active-nemu' : ''">{{encDec.decodeHtml(language=='English'?secondary_menu.VCHMENUNAME:secondary_menu.VCHMENUNAMEHINDI)}}</a>
                    <!-- content page -->
                        <a href="javascript:void(0);" class="screen-reader" (click)="goToContentPage(secondary_menu)" *ngSwitchCase="3" [ngClass]="current_menu.intId == secondary_menu.intId ? 'active-nemu' : ''">{{encDec.decodeHtml(language=='English'?secondary_menu.VCHMENUNAME:secondary_menu.VCHMENUNAMEHINDI)}}</a>
                    <!-- na -->
                        <a href="javascript:void(0);" class="screen-reader" *ngSwitchCase="4" [ngClass]="current_menu.intId == secondary_menu.intId ? 'active-nemu' : ''">{{encDec.decodeHtml(language=='English'?secondary_menu.VCHMENUNAME:secondary_menu.VCHMENUNAMEHINDI)}}</a>
                </li>
                <li class="breadcrumb-item"  *ngIf="has_tertiary_menu" [ngSwitch]="tertiary_menu.INTLINKTYPE">
                    <!-- external page -->
                        <a href="javascript:void(0);" class="screen-reader" (click)='goToExtLink(tertiary_menu.VCHEXTERNALLINK)' *ngSwitchCase="1" [ngClass]="current_menu.intId == tertiary_menu.intId ? 'active-nemu' : ''">{{encDec.decodeHtml(language=='English'?tertiary_menu.VCHMENUNAME:tertiary_menu.VCHMENUNAMEHINDI)}}</a>
                    <!-- plugin page -->
                        <a href="javascript:void(0);" class="screen-reader" (click)="goToPluginPage(tertiary_menu.INTPLUGIN,{'plugin_id':tertiary_menu.intId,'selectPlugin':tertiary_menu.INTPLUGIN})" *ngSwitchCase="2" [ngClass]="current_menu.intId == tertiary_menu.intId ? 'active-nemu' : ''">{{encDec.decodeHtml(language=='English'?tertiary_menu.VCHMENUNAME:tertiary_menu.VCHMENUNAMEHINDI)}}</a>
                    <!-- content page -->
                        <a href="javascript:void(0);" class="screen-reader" (click)="goToContentPage(tertiary_menu)" *ngSwitchCase="3" [ngClass]="current_menu.intId == tertiary_menu.intId ? 'active-nemu' : ''">{{encDec.decodeHtml(language=='English'?tertiary_menu.VCHMENUNAME:tertiary_menu.VCHMENUNAMEHINDI)}}</a>
                    <!-- na -->
                        <a href="javascript:void(0);" class="screen-reader" *ngSwitchCase="4" [ngClass]="current_menu.intId == tertiary_menu.intId ? 'active-nemu' : ''">{{encDec.decodeHtml(language=='English'?tertiary_menu.VCHMENUNAME:tertiary_menu.VCHMENUNAMEHINDI)}}</a>
                </li>
            </ol> 
            <ol class="breadcrumb" *ngIf="check_total_current_menu <= 0">
                <li class="breadcrumb-item"><a routerLink="/" class="screen-reader">{{ 'Home' | translate }}</a></li>
            </ol>
        </nav>




<!-- for employee corner  -->
        <nav aria-label="breadcrumb mb-0" *ngIf="showEmpMen==true">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a routerLink="/" class="screen-reader">{{ 'Home' | translate }}</a></li>
                <li class="breadcrumb-item"><a routerLink="/employeecorner" class="screen-reader">{{ 'EmployeeCorner' | translate }}</a></li>
                <li class="breadcrumb-item"><a href="javascript:void(0);" class="active-nemu screen-reader">{{encDec.decodeHtml(language=='English'?emp_dtl.title:emp_dtl.titleInHindi)}}</a></li>
            </ol>
        </nav>
    </div>  
    <!-- BREADCRUMB AREA - ENDS -->
   
    <div class="inner-page"> 
        <div class="inner-page-details">

 <!-- for content page  -->              
<div class="row" *ngIf="showEmpMen==false"> 
    <div [class]="totalNavMenu > 0 ? 'col-lg-2 col-xl-3 col-xxl-2' : ''" *ngIf="totalNavMenu > 0"> 
        <div [style]="navmenuloadCss"> 
            <app-website-inner-sidenav [datacollection]="{data:p_apirespons}" *ngIf="showComponent"></app-website-inner-sidenav>
        </div> 
    </div>
    <div [class]="totalNavMenu > 0 ? 'col-lg-10 col-xl-9 col-xxl-10' : 'col-lg-12'" *ngIf="showComponent"> 
            <!-- INNER CONTENT - STARTS -->
        <app-content-page [pgAlias]="pageAlias" ></app-content-page>  
        <!-- INNER CONTENT - ENDS -->
    </div>
</div>






<!-- for employee corner  -->
<div class="row" *ngIf="showEmpMen==true"> 
    <div class="col-lg-12" > 
         <!-- INNER CONTENT - STARTS -->
        <app-content-page [pgAlias]="pageAlias"></app-content-page>  
        <!-- INNER CONTENT - ENDS -->
    </div>
</div>






        </div>
    </div> 

</section>

<app-clients></app-clients>

<app-footer></app-footer> 